import React from 'react'

import { getSortIconBySortValue } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'

export const useGetSortIcon = (
  name: 'individualSortValue' | 'matrixSortValue' | 'sequentialSortValue',
) => {
  const sortValue = useAtomValueContext(name)

  type ColumnKeyOf<T> = T extends {
    columnKey: infer U
  }
    ? U
    : never
  type ColumnKey = ColumnKeyOf<typeof sortValue>

  return React.useCallback(
    (columnKey: ColumnKey) => getSortIconBySortValue(sortValue, columnKey),
    [sortValue],
  )
}
